import config from 'environment';

export const fpGroupManagerLinkBuilder = (
  projectId: string,
): string => {
  const url = config.groupManagerURL;
  // 写真へ遷移するURLが設定されていなければエラー画面へ遷移する
  if (url === '') {
    return '/error?type=/error/global/0000&status=500';
  }
  const paramKey = config.groupManagerParameterKeyProjectId;
  if (paramKey === '') {
    return url;
  }
  return `${url}?${config.groupManagerParameterKeyProjectId}=${encodeURIComponent(projectId)}`;
};
